const KEYS = {
  AHA_USER_TYPE: 'AhaUserType',
  SESSION_ID: 'sessionId',
  SELECTED_PROFILE_ID: 'selectedProfileId',
  MAIN_CONTACT_ID: 'mainContactId',
  MAIN_CONTACT: 'mainContact',
  ACCOUNT_CHANNEL_PARTNER_ID: 'accountChannelPartnerID',
  CP_CUSTOMER_ID: 'cpCustomerID',
  PLATFORM_TOKEN: 'authData',
  EVERGENT_ACCESS_TOKEN: 'accessToken',
  EVERGENT_REFRESH_TOKEN: 'evergentRefreshToken',
  EVERGENT_OVAT_TOKEN: 'xAuthToken',
  EVERGENT_OVAT_TOKEN_EXPIRY: 'xAuthTk_ExpTime',
  STATUS: 'status',
  SUBSCRIPTIONS: 'subscriptions',
  SUBSCRIPTION_STATUS: 'subscriptionStatus',
  TVOD_PURCHASE_ALLOWED: 'tvodPurchaseAllowed',
  TVOD_MOVIE_CATALOGS: 'tvodMovieCatalogs_',
  TVOD_PURCHASED_LIST: 'tvodPurchasedList',
  TVOD_TOKEN: 'tvodToken',
  REFRESH_TOKEN: 'refreshToken',
  LOGIN_WITH_EMAIL: 'isLoginWithEmail',
  SUBSCRIPTION_PACKAGE: 'subscriptionPackage',
  SUBSCRIPTION_PRODUCT_CODES: 'subscriptionProductCodes',
  USER_TYPE: 'userType',
  REFRESH_TOKEN_RESPONSE: 'refreshTokenResponseMessage',
  REGION: 'region',
  CITY: 'city',
  TVOD_CONTENT: 'tvodContent',
  LOCATION: 'location',
  REDEEM_TOKEN: 'redeemToken',
  DEVICE_REF: 'deviceref',
  WATCH_LANGUAGE: 'watch-lang',
  DISPLAY_LANGUAGE: 'lang',
  SKIP_CATALOG_SELECTION: 'skipCatalogSelection',
  STOREFRONT_ID: 'storefrontId',
  PROFILE_PREFERENCES: 'profilePreferences',
  REDEEM_STATUS: 'redeemStatus',
  CONFIG: 'configTestData',
  EDGE_WORKER_DATA: 'edgeWorkerData',
  TAMIL_ACTOR_IMAGE: 'tamilActorImage',
  TELUGU_ACTOR_IMAGE: 'teluguActorImage',
  FRESH_LAUNCH: 'freshLaunch',
  ELAPSED_SPLASH: 'elapsedSplash',
  TIME_TO_LOAD_APP: 'timeToLoadApp',
  CURRENT_TAB_ID: 'currentTabId',
  DRM_NAME: 'drmName',
  CURRENT_TAB_NAME: 'currentTabName',
  CHANGE_AUDIO: 'changeAudio',
  SUBTITLE_SIZE: 'subtitleSize',
  SUBTITLE_THEME: 'subtitleTheme',
  SUBTITLE: 'subtitle',
  ANONYMOUS_PREFERRED_LANGUAGES: 'aPreferredLanguages',
  PREFERRED_LANGUAGES: 'PreferredLanguages',
  SELECTED_PROFILE: 'selectedProfile',
  IS_FIRST_LAUNCH: 'isFirstLaunch',
  PENDING_DEEPLINK_URL: 'pendingDeeplinkUrl',
  DL_PREFERRED_LANGUAGES: 'dlPreferredLanguages',
  EVERGENT_ACCESS_TOKEN_EXPIRY: 'accessTokenExp',
} as const;

export { KEYS };
